import { render, staticRenderFns } from "./DisplayStoreItemsDetail2.vue?vue&type=template&id=632d0504&"
import script from "./DisplayStoreItemsDetail2.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsDetail2.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsDetail2.vue?vue&type=style&index=0&id=632d0504&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports